import { Injectable } from '@angular/core';
import {
  FilterCardConfig,
  FilterUIType,
  FilterGroupType,
  FilterConfig,
} from '../filter/types';
import {
  SearchCriterium,
  SearchOperations,
} from '../../core/types/search-criterium';
import { FilterValueLocalService } from '../filter/filter-value-local.service';
import { PageName } from '../../core/types/user-preferences';
import { ClaimOptionValueListService } from '../services/claim-option-value-list.service';
import { AdministratorValueListService } from '../services/administrator-value-list.service';
@Injectable()
export class ClaimListFilterConfigService {
  config: FilterCardConfig;
  pageName: PageName;
  initialFilters: SearchCriterium[];

  constructor(
    claimOptionValueListService: ClaimOptionValueListService,
    administratorValueListService: AdministratorValueListService
  ) {
    this.pageName = PageName.CLAIMS;

    this.config = {
      id: new FilterConfig({
        path: 'id',
        type: FilterUIType.INPUT,
        group: FilterGroupType.CLAIM,
        availableOperations: [
          SearchOperations.EQUALS,
          SearchOperations.LESS_THAN,
          SearchOperations.GREATER_THAN,
        ],
      }),
      completed: new FilterConfig({
        path: 'completed',
        type: FilterUIType.DROPDOWN,
        group: FilterGroupType.CLAIM,
        translationKey: 'claims.completed',
        valueListService: new FilterValueLocalService([
          {
            value: true,
            displayText: 'global.yes',
          },
          {
            value: false,
            displayText: 'global.no',
          },
        ]),
        availableOperations: [SearchOperations.EQUALS],
      }),
      'claimOption.code': new FilterConfig({
        path: 'claimOption.code',
        type: FilterUIType.DROPDOWN,
        group: FilterGroupType.CLAIM,
        translationKey: 'claims.option',
        valueListService: claimOptionValueListService,
        availableOperations: [SearchOperations.EQUALS],
      }),
      accepted: new FilterConfig({
        path: 'accepted',
        type: FilterUIType.DROPDOWN,
        group: FilterGroupType.CLAIM,
        translationKey: 'claims.accepted',
        valueListService: new FilterValueLocalService([
          {
            value: true,
            displayText: 'global.yes',
          },
          {
            value: false,
            displayText: 'global.no',
          },
        ]),
        availableOperations: [SearchOperations.EQUALS],
      }),
      completedAt: new FilterConfig({
        path: 'completedAt',
        translationKey: 'claims.completedAt',
        type: FilterUIType.DATEPICKER,
        group: FilterGroupType.CLAIM,
        availableOperations: [
          SearchOperations.EQUALS,
          SearchOperations.LESS_THAN,
          SearchOperations.GREATER_THAN,
        ],
      }),
      'completedBy.id': new FilterConfig({
        path: 'completedBy.id',
        translationKey: 'claims.completedBy',
        type: FilterUIType.MULTISELECT,
        group: FilterGroupType.CLAIM,
        valueListService: administratorValueListService,
        availableOperations: [SearchOperations.IN],
      }),
      notes: new FilterConfig({
        path: 'notes',
        type: FilterUIType.INPUT,
        group: FilterGroupType.CLAIM,
        availableOperations: [SearchOperations.LIKE],
      }),
      time: new FilterConfig({
        path: 'time',
        translationKey: 'claims.createDate',
        type: FilterUIType.DATEPICKER,
        group: FilterGroupType.CLAIM,
        availableOperations: [
          SearchOperations.EQUALS,
          SearchOperations.LESS_THAN,
          SearchOperations.GREATER_THAN,
        ],
      }),
      'user.civilId': new FilterConfig({
        path: 'user.civilId',
        type: FilterUIType.INPUT,
        group: FilterGroupType.CLIENT,
        availableOperations: [SearchOperations.EQUALS, SearchOperations.LIKE],
      }),
      'user.id': new FilterConfig({
        path: 'user.id',
        type: FilterUIType.INPUT,
        group: FilterGroupType.CLIENT,
        availableOperations: [
          SearchOperations.EQUALS,
          SearchOperations.LESS_THAN,
          SearchOperations.GREATER_THAN,
        ],
      }),
    };

    this.initialFilters = [
      {
        key: 'claimOption.code',
        operation: SearchOperations.EQUALS,
        value: '',
      },
      {
        key: 'completed',
        operation: SearchOperations.EQUALS,
        value: '',
      },
      {
        key: 'user.id',
        operation: SearchOperations.EQUALS,
        value: '',
      },
      {
        key: 'user.civilId',
        operation: SearchOperations.EQUALS,
        value: '',
      },
    ];
  }
}
